import { Alert, AlertTitle } from '@mui/material'

import { useTexts } from '../useTexts'

export function Body() {
  const texts = useTexts()

  return (
    <Alert severity="warning">
      <AlertTitle>{texts.requestChangePlanTitle}</AlertTitle>
      {texts.requestChangePlanDescription}
    </Alert>
  )
}
